import { X } from "lucide-react";
import { ErrorIconGrid } from "@/components/ErrorIconGrid";

// Static preview of the app's "Mark an Identified Error" screen (screenshot 1).
export function IconBoardMockup({ className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <div className="relative rounded-[2.6rem] border-8 border-[#151614] bg-[#151614] shadow-2xl w-[300px] h-[610px] overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 z-20 w-28 h-6 bg-[#151614] rounded-b-2xl" />
        <div className="relative w-full h-full rounded-[2rem] bg-white overflow-hidden flex flex-col">
          <div className="flex items-center justify-between px-5 pt-3.5 pb-1 text-[11px] font-semibold text-[#2B2B2B]">
            <span>9:41</span>
            <span className="text-[#2B2B2B]/70">▪▪▪ ▪ 􀛨</span>
          </div>
          <div className="flex items-start justify-between px-5 pt-2 pb-3">
            <div>
              <h4 className="font-display font-extrabold text-[19px] text-[#1a1a1a] leading-tight">Mark an Identified Error</h4>
              <p className="text-[11px] text-[#2B2B2B]/45 mt-0.5">Tap an icon · swipe for more</p>
            </div>
            <span className="grid place-items-center w-9 h-9 rounded-full bg-[#F1F2F3] text-[#2B2B2B] shrink-0">
              <X size={17} strokeWidth={2.5} />
            </span>
          </div>
          <div className="flex-1 overflow-hidden px-3">
            <ErrorIconGrid />
          </div>
          <div className="flex items-center justify-center gap-1.5 py-3">
            <span className="w-5 h-1.5 rounded-full bg-[#12A594]" />
            <span className="w-1.5 h-1.5 rounded-full bg-[#2B2B2B]/20" />
          </div>
          <div className="mx-auto mb-2 w-32 h-1 rounded-full bg-[#2B2B2B]/25" />
        </div>
      </div>
    </div>
  );
}
